import { AttachedCommunicationType } from "@/Common/Models/AttachedCommunication/AttachedCommunicationType";
import { Person } from "@/Common/Models/Person/Person";
import { MessageOrTaskContext } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface ICommunicationsSectionProps {
    model: IPatientMedicalNoteModel;
    isReadOnly: boolean;
    patientId: string;
    encounter: Encounter
}

function CommunicationsSection(props: ICommunicationsSectionProps): JSX.Element {
    const taskStatusClick = (e: React.MouseEvent): void => {
        e.stopPropagation();

        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.ShowAttachedCommunicationsList,
            {
                attachedCommunications: props.model.get("IndividualTasksLinkedItems"),
                context: AttachedCommunicationType.Task,
                eventTarget: e.target,
                eventY: e.clientY,
                eventX: e.clientX
            }
        );
    };

    const messageStatusClick = (e: React.MouseEvent): void => {
        e.stopPropagation();

        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.ShowAttachedCommunicationsList,
            {
                attachedCommunications: props.model.get("IndividualMessageLinkedItems"),
                context: AttachedCommunicationType.Message,
                eventTarget: e.target,
                eventY: e.clientY,
                eventX: e.clientX
            }
        );
    };

    const showMessageTaskPopup = (isTask: boolean): void => {
        sessionStore.dispatch(
            LocalOperations.SendTaskOrMessageModel.Show_TaskOrMessage_Popup,
            {
                isTask: isTask,
                patient: Person.FromPatient(patientStore.PatientModels[props.patientId]),
                target: MessageOrTaskContext.Encounter,
                encounterId: props.encounter.Id
            }
        );
    };

    const showRecallPopup = (): void => {
        sessionStore.dispatch(
            LocalOperations.SendRecallPopup.Show_SendRecall_Popup,
            {
                patient: Person.FromPatient(patientStore.PatientModels[props.patientId]),
                isSentFromEncounter: true,
                encounterId: props.encounter.Id
            }
        );
    };

    const recallStatusClick = (e: React.MouseEvent): void => {
        e.stopPropagation();

        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.ShowAttachedCommunicationsList,
            {
                attachedCommunications: props.model.get("IndividualRecallLinkedItems"),
                context: AttachedCommunicationType.Recall,
                eventTarget: e.target,
                eventY: e.clientY,
                eventX: e.clientX
            }
        );
    };

    return (
        <tr>
            <td className="c1">
                <strong>{cacheStore.GetString("CommunicationsLabel")}</strong>
            </td>
            <td className="c2 bottom-pad">
                <div className="tb-row tb" data-cy="communicationsSection-links">
                    {!props.isReadOnly && (
                        <div className="add-btn-column">
                            <a onClick={() => showRecallPopup()}>[+] </a>
                        </div>
                    )}
                    <div className="note-items-column">
                        <span>
                            {!props.isReadOnly && (
                                <a onClick={() => showRecallPopup()}>
                                    {cacheStore.GetString("NewRecallLabel")}
                                </a>
                            )}
                            {!isArrayNullOrUndefinedOrEmpty(props.model.get("IndividualRecallLinkedItems")) && (
                                <span
                                    onClick={e => recallStatusClick(e)}
                                    className={`margin-xs-left pointer ${props.model.get("AreAllRecallsCompleted") ? "circle-green" : "circle-orange"}`}
                                >
                                    {props.model.get("IndividualRecallLinkedItems").length}
                                </span>
                            )}
                        </span>
                        <span className="padding-sm-left">|</span>
                        <span className="padding-sm-left">
                            {!props.isReadOnly && (
                                <a onClick={() => showMessageTaskPopup(false)}>
                                    {cacheStore.GetString("NewMessageLabel")}
                                </a>
                            )}
                            {!isArrayNullOrUndefinedOrEmpty(props.model.get("IndividualMessageLinkedItems")) && (
                                <span
                                    onClick={e => messageStatusClick(e)}
                                    className={`margin-xs-left pointer ${props.model.get("AreAllMessagesRead") ? "circle-green" : "circle-orange"}`}
                                >
                                    {props.model.get("IndividualMessageLinkedItems").length}
                                </span>
                            )}
                        </span>
                        <span className="padding-sm-left">|</span>
                        <span className="padding-sm-left">
                            {!props.isReadOnly && (
                                <a onClick={() => showMessageTaskPopup(true)}>
                                    {cacheStore.GetString("NewTaskLabel")}
                                </a>
                            )}
                            {!isArrayNullOrUndefinedOrEmpty(props.model.get("IndividualTasksLinkedItems")) && (
                                <span
                                    onClick={e => taskStatusClick(e)}
                                    className={`margin-xs-left pointer ${props.model.get("AreAllTasksCompleted") ? "circle-green" : "circle-orange"}`}
                                >
                                    {props.model.get("IndividualTasksLinkedItems").length}
                                </span>
                            )}
                        </span>
                    </div>
                </div>
            </td>
        </tr>
    );
}

export { CommunicationsSection };
